import { useContext } from 'react'

import ServerSideContext from '../contexts/ServerSideContext'

const useIsServerSide = () => {
  const isServerSide = useContext(ServerSideContext)
  return isServerSide
}

export default useIsServerSide
